import React, { useState, useEffect } from 'react';
import { Grid, Backdrop,Snackbar, CircularProgress, Typography, TextField, Button, Autocomplete } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// project imports
import SubCard from 'src/components/cards/SubCard';
import ThemeCustomization from 'src/themesNew';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import Page from 'src/components/Page';
import {
  Container,
  Card,
  CardHeader,
} from '@material-ui/core';
import {
  Select,
  MenuItem,
  Divider,
  CardContent,
} from '@material-ui/core';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

// ==============================|| PROFILE 1 - PROFILE ACCOUNT ||============================== //

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Role = () => {

  const theme = useTheme();




  const classes = useStyles();
  const [yetki, setYetki] = useState([]);

  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [EmployeeNr, setEmployeeNr] = useState(0);
  const [RoleTypes, setRoleTypes] = useState([]);
  const [NewRoleType, setNewRoleType] = useState('');
  const [loadingCombo, setLoadingCombo] = useState(false);
  const [UsersData, setUsersData] = useState([]);
  const [User, setUser] = useState([]);
  const [UserRolesData, setUserRolesData] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
});


  const [TypeDsc, setTypeDsc] = useState('');
  const handleAddRole = () => {
    if (!User?.Id || !NewRoleType) {
    setresponseMessage('Lütfen yetki tipi ve kullanıcı seçiniz!...');
    setUyariTip('error');
    setUyari(true);
    return;
    }
    setLoading(true);
    axios.get(`SetEmployeeRoles/${User?.Id}/${NewRoleType}`).then((response) => {
      setLoading(false);
      GetUserRoles(User?.Id);
    });
  };


  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });

  }

  const handleUsers = (val) => {
    setLoadingCombo(true);
    axios.get(`GetEmployeeSearch/${val}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setUsersData(response.data);
        } else {
          setUsersData([]);
        }
        setLoadingCombo(false);
      });
  }


  const getEmployeeRole = () => {
    setLoading(true);
    axios.get(`GetEmployeeRole`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setRoleTypes(response.data);
        } else {
          setRoleTypes([]);
        }
        setLoading(false);
      });

  }

  const GetUserRoles = (val) => {
    setLoading(true);
    axios.get(`GetUserRoles/${val}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setUserRolesData(response.data);
        } else {
          setUserRolesData([]);
        }
        setLoading(false);
      });
  }

  const setNewRoleTypeParam = (Param) => {
    setNewRoleType(Param);

    var TypeDsc = RoleTypes.filter(x => x.Id === Param)[0]?.Detail;
    setTypeDsc(TypeDsc);

  }

  const setUserParam = (val) => {
    setUser(val);
    GetUserRoles(val?.Id);
  }

  useEffect(() => {
    getEmployeeRole();
    getEmployeeYetki();
  }, []);


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setUyari(false);
};

  return (
    <Page className={classes.root}>
      <ThemeCustomization>
        {
          loading ?
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
          <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
                ></Alert>
            </Snackbar>
        <Container maxWidth="xl">
          <Card>
            <CardHeader title={<Typography variant="h4">Yetki Yönetimi</Typography>} />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={8}>
                  <SubCard title="İşlem" style={{ minHeight: 400 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel htmlFor="outlined-age-native-simple">Yetki Tipi</InputLabel>
                          <Select
                            label="Yetki Tipi"
                            value={NewRoleType}
                            onChange={(e) => setNewRoleTypeParam(e.target.value)}
                            disabled={yetki.find(item => item.ALAN_ADI === 'dsNewRoleType')?.DISABLE_ALAN}
                            fullWidth
                            size="small"
                            inputProps={{
                              name: 'age',
                              id: 'outlined-age-native-simple',
                            }}
                          >
                            {RoleTypes.map((type) => (
                              <MenuItem key={type.Id} value={type.Id}>
                                {type.Dsc}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={UsersData}
                          value={User}
                          getOptionLabel={(i) => i?.Dsc || ""}
                          onChange={(event, val) => setUserParam(val)}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsUser')?.DISABLE_ALAN}
                          onInputChange={(event, newInputValue) => {
                            handleUsers(newInputValue);
                          }}
                          fullWidth
                          renderInput={(params) => <TextField {...params} label="Kullanıcı"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingCombo && <CircularProgress color="primary" size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ textTransform: 'none' }}
                          startIcon={<AccessibilityIcon />}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsAddRole')?.DISABLE_ALAN}
                          onClick={handleAddRole}>
                          Ekle
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Divider />
                        <Typography variant="h6">
                          <br />
                          {`${TypeDsc}`}</Typography>
                      </Grid>
                    </Grid>
                  </SubCard>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  <SubCard title="Yetki Bilgileri" style={{ minHeight: 400 }}>
                    {UserRolesData.length > 0 &&
                      UserRolesData.map((item) => (
                        <div key={item.Id}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography><b>Kullanıcı : </b>{`${item.User}`}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <Typography><b>Yetki : </b>{`${item.Role}`}</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                        </div>
                      ))}
                  </SubCard>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </ThemeCustomization>
    </Page>
  );
};

export default Role;
